import { Building } from "./BuildingStatus";
import { useEffect, useState } from "react";
import { Select, SelectOption } from "./common/MuiSelect";
import {MeterApi} from "../client/MeterClient";

export interface BuildingInputProps {
    buildings: Building[]
    building?: Building
    disabled?: boolean
    onBuildingChange: (b: Building) => void
    className?: string
    testId?: string
}

export interface MpanInputProps {
    meters: MeterApi[]
    meter?: MeterApi
    disabled?: boolean
    onBuildingChange: (b: MeterApi) => void
    className?: string
    testId?: string
}
export interface GenericInputProps <T extends SelectOption> {
    meters: T[]
    meter?: T
    disabled?: boolean
    onBuildingChange: (b: T) => void
    className?: string
    testId?: string
    label: string
}

export const GenericMpanSelect =<T extends SelectOption,>({ meters, meter, disabled, onBuildingChange, className, testId, label }: GenericInputProps<T>)=> {
    const [internalMpan, setInternalMpan] = useState<string | undefined>(meter?.id ?? undefined)


    useEffect(() => {
        setInternalMpan(meter?.id)
    }, [meter])

    const options: { id: string, label: string }[] = meters.map(m => ({id: m.id, label: m.label}))
    const initialValue = options.find(it => it.id === internalMpan) ?? undefined


    return <Select className={'mb-3 ' + className} label={label} data-testid={testId ? testId : 'mpanId'}
                   disabled={disabled}
                   initialValue={initialValue}
                   onChange={(e: SelectOption) => {
                       const newBuilding = meters.find(b => b.id === e.id)!
                       setInternalMpan(newBuilding.id)
                       onBuildingChange(newBuilding)
                   }}
                   options={options}/>
}

export const MpanInput =({ meters, meter, disabled, onBuildingChange, className, testId }: MpanInputProps)=> {

    const options: SelectOption[] = meters.map(m =>({ id: m.mpan, label: m.description }))
    const onChange = (e: SelectOption) => {
        const newBuilding = meters.find(b => b.mpan === e.id)!
        onBuildingChange(newBuilding)
    };
    const meter1: { id: string; label: string } | undefined= (meter?.mpan && meter.description) ? {id:meter?.mpan, label:meter?.description } : undefined

    return <GenericMpanSelect
        meters={options}
        meter={ meter1 }
        onBuildingChange={onChange}
        disabled={disabled}
        className={className}
        testId={testId? testId : 'mpanId'}
    label={'mpan'}/>
}

export const BuildingInput = ({ buildings, building, disabled, onBuildingChange, className, testId }: BuildingInputProps) => {

    const options = buildings.map(it => ({ ...it, label: it.name, id: it.id.toString() }));
    const building1: { id: string; label: string } | undefined= (building?.id && building.name) ? {id:building?.id.toString(), label:building?.name } : undefined
    const onChange = (e: SelectOption) => {
        const newBuilding = buildings.find(b => b.id === Number(e.id))!;
        onBuildingChange(newBuilding)
    };

    return <GenericMpanSelect
        meters={options}
        meter={ building1 }
        onBuildingChange={onChange}
        disabled={disabled}
        className={className}
        testId={testId ? testId : 'buildingInput'}
        label={'Site'}
    />
}

export interface StatefulSelectProps {
    options: { id: number | string, name: string }[]
    selected?: { id: number | string, name: string }
    onChange: (b: { id: number | string, name: string }) => void
    className?: string
    displayName: string
    testId?: string
    disabled?: boolean
}

export const StatefulSelect = ({ options, selected, onChange, displayName, testId = 'stateful-select', className, disabled = false }: StatefulSelectProps) => {
    const [internalSelected, setInternalSelected] = useState<number | string>()

    useEffect(() => {
        setInternalSelected(selected?.id)
    }, [selected])

    function handleChange(e: SelectOption) {
        const newSelection = options.find(b => b.id == e.id)!;
        setInternalSelected(newSelection.id)
        onChange(newSelection)
    }

    const selectableOptions = options.map(it => ({ id: it.id.toString(), label: it.name }))

    const initialVal = internalSelected ? selectableOptions.find(it => it.id === internalSelected.toString()) : undefined

    return <Select className={className} label={displayName} data-testid={testId} initialValue={initialVal}
        onChange={handleChange}
        options={selectableOptions}
        disabled={disabled} />
}
